import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./SearchBar.module.css";
import { useTranslation } from "react-i18next";

/**
 * Interactive component. A search bar to search for certain ibos.
 * Includes an optional delay for onInput.
 * Includes an optional minimum value before onInput can be called.
 */
export function SearchBar({ placeholderText, onInput, searchDelay, minChar }) {
  const {t} = useTranslation();
  const [input, setInput] = useState("");

  useEffect(() => {
    if (input.length >= minChar) {
      const timer = setTimeout(() => {
        onInput(input);
      }, searchDelay);

      return () => clearTimeout(timer);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input, onInput, searchDelay]);

  console.log(placeholderText)

  return (
    <div>
      <label htmlFor="search-bar" hidden />
      <input
        className={styles.input}
        type="search"
        name="search-bar"
        placeholder={t(placeholderText)}
        onChange={(key) => setInput(key.target.value)}
      />
    </div>
  );
}

SearchBar.propTypes = {
  /**
   * Placeholder text for the search bar.
   */
  placeholderText: PropTypes.string,
  /**
   * Performs the search when the user starts typing.
   */
  onInput: PropTypes.func,
  /**
   * Delay in ms before onInput is called.
   */
  searchDelay: PropTypes.number,
  /**
   * Minimum characters that need to be exceeded before onInput is fired.
   * Ex. If minChar is 2, the onInput event will not fire until the input value is greater than 2.
   */
  minChar: PropTypes.number,
};

SearchBar.defaultProps = {
  /**
   * If no value is provided, it will default to no delay.
   */
  searchDelay: 0,
  /**
   * If no value is provided, the event will fire after each keystroke.
   */
  minChar: 0,
};
